import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const HelpDeskServices = {};

HelpDeskServices.helpDeskDataCollect = (Id) => AxiosRequest.get(
  `/${route.helpDesk}/tickets/ticket-details/${Id}`
);

HelpDeskServices.allTickets = (payload) => AxiosRequest.post(
    `/${route.helpDesk}/tickets/ticket-list`,
    payload,

  )

HelpDeskServices.allCategories = (payload) => AxiosRequest.post(
  `/${route.helpDesk}/tickets/categories`,
  payload,
)

HelpDeskServices.allStatus = (orgId) => AxiosRequest.get(
  `/${route.helpDesk}/tickets/statuslist/${orgId}?`,
)

HelpDeskServices.createTicket = (payload) => AxiosRequest.postForm(
  `/${route.helpDesk}/tickets/create-ticket`,
  payload,
)

HelpDeskServices.replyTicket = (payload) => AxiosRequest.postForm(
  `/${route.helpDesk}/tickets/reply`,
  payload,
)

HelpDeskServices.config = (payload) => AxiosRequest.post(
  `/${route.productCatalog}/api/v1/configuration/get`,
  payload,
)

// HelpDeskServices.ticketDetails = (Id) => AxiosRequest.get(
//   `/${route.helpDesk}/tickets/ticket-details/${Id}?`,
// )

export default HelpDeskServices;